module.exports = __webpack_public_path__ + "static/GraphQL-7ef7059e3a627c7f3ce3a1fa58814109.png";